import React from 'react';

export default function Alert({ type, children, className = '', ...props }) {
    const alertClass = `flash ${type} ${className}`.trim();

    return (
        <div className={alertClass} {...props}>
            {children}
        </div>
    );
}